import  { useEffect, useState } from "react";
import {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterListing,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetRegisterSuccess,
  resetFixedAssetRegisterTotalCount,
  resetSingleFixedAsset,
} from "../../redux/fixedAsset";
import { resetSession } from "../../redux/auth";
import {
  deleteFixedAssetRegisterAction,
  getFixedAssetRegisterListing,
  getSingleFixedAsset,
  postFixedAssetVerificationAction,
} from "../../redux/fixedAsset/actions";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import SingleCard from "../../components/PhysicalVerification/SingleCard";
import {
  ErrorSuccessModal,
  TableLoader,
  EmptyListPage,
  CommonHeader,
} from "../../components/commons";
import QrCodeScanner from "../../components/PhysicalVerification/QrCodeScanner";
import { FixedAssetVerificationType } from "../../commonTypes/fixedAssetRegisterTypes";
import { SearchIcon } from "../../components/Icon";
import useDebounce from "../../customHooks/useDebounce";
import { EmptyClientList, UnauthorizeImage } from "../../assets/images";
import "./style.scss";
import {
  getDepartmentListAction,
  resetDepartmentList,
} from "../../redux/clientSettings";
import { GetDepartmentListPayloadType } from "../../commonTypes/clientSettingsTypes";
import { DepartmentListType } from "../../redux/clientSettings/clientSettingTypes";
import FixedAssetFilter from "../../components/FixedAssetRegister/FixedAssetRegisterSortingFilter/FixedAssetFilter";
import FixedAssetSorting from "../../components/FixedAssetRegister/FixedAssetRegisterSortingFilter/FixedAssetSorting";
import PhysicalVerificationDownloadReport from "../../components/PhysicalVerification/PhysicalVerificationDownloadReport";
import { useParams } from "react-router-dom";

type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;
  departmentList: DepartmentListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchResetFixedAssetRegisterListing: () => void;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchGetFixedAssetRegisterListing: (data: any) => void;
  dispatchGetSingleFixedAsset: (data: any) => void;
  dispatchPostFixedAssetVerificationAction: (
    data: FixedAssetVerificationType
  ) => void;
  finacAssetListing: [];
  dispatchDeleteFixedAssetRegisterAction: (data: any) => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  dispatchResetFixedAssetRegisterTotalCount: () => void;
  dispatchResetFixedAssetRegisterStatusCode: () => void;
  dispatchResetDepartmentList: () => void;
  dispatchGetDepartmentList: (data: GetDepartmentListPayloadType) => void;
  dispatchResetSingleFixedAsset: () => void;
  totalCount: number;
  singleFixedAsset: any;
};

const PhysicalVerification = ({
  history,
  token,
  statusCode,
  success,
  message,
  fetching,
  error,
  singleFixedAsset,
  departmentList,
  dispatchResetSession,
  dispatchGetSingleFixedAsset,
  dispatchResetFixedAssetRegisterError,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterListing,
  dispatchGetFixedAssetRegisterListing,
  dispatchGetDepartmentList,
  dispatchResetDepartmentList,
  finacAssetListing,
  dispatchResetFixedAssetRegisterMessage,
  dispatchResetFixedAssetRegisterTotalCount,
  dispatchResetFixedAssetRegisterStatusCode,
  dispatchPostFixedAssetVerificationAction,
  dispatchResetSingleFixedAsset,
  totalCount,
}: AppProps) => {
  const {id}:any=useParams()
  const client_code = history?.location?.state?.client_code ? history?.location?.state?.client_code : id;

  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  const persistSearch = history?.location?.state?.searchValue
    ? history?.location?.state?.searchValue
    : "";
  const [searchValue, setSearchValue] = useState(persistSearch);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [listData, setListData] = useState<any>([]);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [apiCall, setApiCall] = useState(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [departmentListValue, setDepartmentValue] = useState<any>([]);
  const [multiSelectData, setMultiSelectData] = useState<any>({
    Obsolete: "",
    Missing: "",
    Good: "",
    Bad: "",
    to_capitalize: "",
  });
  const [locationListValue, setLocationValue] = useState<any>([]);
  const [selectLoction, setSelectLoction] = useState<any>({
    label: "Select",
    value: null,
    logo: "",
  });

  const clientCode = history?.location?.state?.client_code;
  const [filterConditionData, setFilterConditionData] = useState<any>({
    Obsolete: false,
    Missing: false,
    Good: false,
    Bad: false,
    to_capitalize: false,
  });
  const [qrcodeToggle, setQRCodeToggle] = useState(0);
  const [multiFilterMaintain, setMultiFilterMaintain] = useState({
    Obsolete: false,
    Missing: false,
    Good: false,
    Bad: false,
    to_capitalize: false,
    qrCode: 0,
    location: {
      label: "Select",
      value: null,
      logo: "",
    },
    department: {
      label: "Select",
      value: null,
    },
  });
  const [data, setData] = useState<any>([]);
  const [sortByLocation, setSortByLocation] = useState({ name: "", value: "" });
  const [sortByDeparment, setSortByDeparment] = useState({
    name: "",
    value: "",
  });
  const [sortByCf, setSortByCf] = useState({ name: "", value: "" });
  // const [sortByRecent, setSortByRecent] = useState({ name: "", value: "" });
  const [sortByOldest, setSortByOldest] = useState({ name: "", value: "" });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectDepartment, setSelectDepartment] = useState<any>({
    label: "Select",
    value: null,
  });

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetFixedAssetRegisterListing();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetFixedAssetRegisterTotalCount();
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterError();
    dispatchResetSingleFixedAsset();
    let finalData = {
      token,
      client_code,
      limit,
      offset,
      searchValue,
      is_verified: 1,
      sort_by: sortByLocation?.name
      ? "location"
      : sortByDeparment?.name
      ? "department"
      : sortByOldest?.name
      ? "updated_at"
      : "",
    sort_by_value: sortByLocation?.value
      ? sortByLocation?.value
      : sortByDeparment?.value
      ? sortByDeparment?.value
      : sortByOldest?.value
      ? sortByOldest?.value
      : "",
    };
    dispatchGetFixedAssetRegisterListing(finalData);
    setApiCall(true);
    setData([
      { name: "", value: "" },
      { name: "Location - A to Z", value: "asc" },
      { name: "Location - Z to A", value: "desc" },
      { name: "Department - A to Z", value: "asc" },
      { name: "Department - Z to A", value: "desc" },
    ]);
    if (sortByDeparment?.name) {
      handleSort(sortByDeparment);
    } else if (sortByLocation?.name?.length) {
      handleSort(sortByLocation);
    } else if (sortByOldest?.name) {
      handleSort(sortByOldest);
    } else {
      handleSort({ name: "", value: "" });
    }
  }, [isVisible]);

  useEffect(() => {
    if (apiCall) {
      if (offset > 0) {
        fetchNewData(searchValue);
      } else {
        setOffset(0);
      }
    }
  }, [isVisible]);

  useEffect(() => {
    dispatchResetDepartmentList();
    setDepartmentValue([]);
    if (token && clientCode) {
      let finalData: GetDepartmentListPayloadType = {
        token,
        client_code: clientCode,
      };
      dispatchGetDepartmentList(finalData);
    }
  }, []);

  useEffect(() => {
    if (departmentList?.length) {
      let filterStatus = departmentList?.filter(
        (item: any) => item?.status === 1
      );

      let newData = filterStatus?.map((item: any) => {
        return {
          label: item?.department_name,
          value: item?.id,
        };
      });
      setDepartmentValue([...newData]);
    }
  }, [departmentList]);

  useEffect(() => {
    if (finacAssetListing?.length === 0) {
      setListData(finacAssetListing);
    } else if (offset > 0 && finacAssetListing?.length > 0 && !fetching) {
      setListData((prv: any) => [...prv, ...finacAssetListing]);
    } else {
      setListData(finacAssetListing);
    }
  }, [finacAssetListing]);

  useEffect(() => {
    setMultiSelectData((prev: any) => {
      return {
        Obsolete: filterConditionData?.Obsolete
          ? filterConditionData?.Obsolete
          : "",
        Missing: filterConditionData?.Missing
          ? filterConditionData?.Missing
          : "",
        Good: filterConditionData?.Good ? filterConditionData?.Good : "",
        Bad: filterConditionData?.Bad ? filterConditionData?.Bad : "",
        to_capitalize: filterConditionData?.to_capitalize
          ? filterConditionData?.to_capitalize
          : "",
      };
    });
  }, [finacAssetListing]);

  useEffect(() => {
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetFixedAssetRegisterError();
    const trueKeys: string[] = Object.keys(filterConditionData).filter(
      (key) => filterConditionData[key] === true
    );
    const resultString = trueKeys.join(",");
    let finalData = {
      token,
      client_code,
      limit,
      offset,
      searchValue,
      is_verified: 1,
      sort_by: sortByLocation?.name
      ? "location"
      : sortByDeparment?.name
      ? "department"
      : sortByOldest?.name
      ? "updated_at"
      : "",
    sort_by_value: sortByLocation?.value
      ? sortByLocation?.value
      : sortByDeparment?.value
      ? sortByDeparment?.value
      : sortByOldest?.value
      ? sortByOldest?.value
      : "",
      condition: resultString,
      department: selectDepartment?.value ? selectDepartment?.value : "",
    };
    if (totalCount) {
      if (offset < totalCount) {
        dispatchGetFixedAssetRegisterListing(finalData);
      }
    } else {
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  }, [offset , sortByLocation ,sortByDeparment , sortByOldest ]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData(searchValue);
      }
    },
    500,
    [searchValue]
  );

  const handleFilterReset = () => {
    setMultiFilterMaintain({
      Obsolete: false,
      Missing: false,
      Good: false,
      Bad: false,
      to_capitalize: false,
      qrCode: 0,
      location: {
        label: "Select",
        value: null,
        logo: "",
      },
      department: {
        label: "Select",
        value: null,
      },
    });
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (finacAssetListing?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [finacAssetListing]);

  const onClose = () => {
    handleFilterReset();
    setIsVisible(false);
  };

  const fetchNewData = (search: string) => {
    if (token) {
      setOffset(0);
      dispatchResetFixedAssetRegisterStatusCode();
      dispatchResetFixedAssetRegisterSuccess();
      dispatchResetFixedAssetRegisterMessage();
      dispatchResetFixedAssetRegisterError();
      const trueKeys: string[] = Object.keys(filterConditionData).filter(
        (key) => filterConditionData[key] === true
      );
      const resultString = trueKeys.join(",");
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
          ? "location"
          : sortByDeparment?.name
          ? "department"
          : sortByOldest?.name
          ? "updated_at"
          : "",
        sort_by_value: sortByLocation?.value
          ? sortByLocation?.value
          : sortByDeparment?.value
          ? sortByDeparment?.value
          : sortByOldest?.value
          ? sortByOldest?.value
          : "",
        is_verified: 1,
        searchValue: searchValue,
        condition: resultString,
        department: selectDepartment?.value ? selectDepartment?.value : "",
        limit,
        offset,
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };

  const handleSubmit = (condition: string, id: string) => {
    handleFilterReset();
    let finalData: FixedAssetVerificationType = {
      token,
      condition,
      fixed_asset_id: id,
      client_code,
    };
    dispatchPostFixedAssetVerificationAction(finalData);
  };

  const handleReset = () => {
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();
    // dispatchResetFixedAssetRegisterTotalCount();
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterError();
    dispatchResetSingleFixedAsset();
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setOffset(0);
    setSearchValue(value);
    if (value?.length === 0) {
      const trueKeys: string[] = Object.keys(filterConditionData).filter(
        (key) => filterConditionData[key] === true
      );
      const resultString = trueKeys.join(",");
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
        ? "location"
        : sortByDeparment?.name
        ? "department"
        : sortByOldest?.name
        ? "updated_at"
        : "",
      sort_by_value: sortByLocation?.value
        ? sortByLocation?.value
        : sortByDeparment?.value
        ? sortByDeparment?.value
        : sortByOldest?.value
        ? sortByOldest?.value
        : "",
        is_verified: 1,
        searchValue: "",
        condition: resultString,
        limit,
        offset,
        department: selectDepartment?.value ? selectDepartment?.value : "",
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };

  const getSingleData = (id: string) => {
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterError();
    if (id) {
      let finalData = {
        token,
        client_code,
        id,
      };
      dispatchGetSingleFixedAsset(finalData);
    }
  };

  const handleLoctionChange = (e: any) => {
    setSelectLoction({
      label: e.label,
      value: e.value,
      logo: e?.logo?.file_url,
    });
  };

  const clearFilter = () => {
    delete history?.location?.state?.filterData;
    dispatchResetFixedAssetRegisterListing();
    setListData([]);
    setFilterConditionData(() => {
      return {
        Obsolete: false,
        Missing: false,
        Good: false,
        Bad: false,
        to_capitalize: false,
      };
    });
    setQRCodeToggle(0);
    setMultiSelectData([]);
    setSelectLoction({
      label: "Select",
      value: null,
      logo: "",
    });
    setSelectDepartment({
      label: "Select",
      value: null,
    });
    const trueKeys: string[] = Object.keys(filterConditionData).filter(
      (key) => filterConditionData[key] === true
    );
    const resultString = trueKeys.join(",");
    if (offset === 0) {
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
        ? "location"
        : sortByDeparment?.name
        ? "department"
        : sortByOldest?.name
        ? "updated_at"
        : "",
      sort_by_value: sortByLocation?.value
        ? sortByLocation?.value
        : sortByDeparment?.value
        ? sortByDeparment?.value
        : sortByOldest?.value
        ? sortByOldest?.value
        : "",
        is_verified: 1,
        searchValue: "",
        condition: "",
        department: "",
        limit,
        offset,
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    } else {
      setOffset(0);
    }
  };
  const handleSort = (data: any) => {
    setOffset(0);
    if (
      data?.name === "Department - A to Z" ||
      data?.name === "Department - Z to A"
    ) {
      setSortByDeparment(data);
      setSortByLocation({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
    } else if (
      data?.name === "Location - Z to A" ||
      data?.name === "Location - A to Z"
    ) {
      setSortByLocation(data);
      setSortByDeparment({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
    } else if (data?.name === "Oldest first") {
      setSortByOldest(data);
      setSortByDeparment({ name: "", value: "" });
      setSortByLocation({ name: "", value: "" });
    } else if (data?.name === "Newest first") {
      setSortByLocation({ name: "", value: "" });
      setSortByDeparment({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
    }
  };
  const handleDepartmentChange = (e: any) => {
    setSelectDepartment({
      label: e.label,
      value: e.value,
    });
  };

  const handleApplyFilterData = () => {
    setMultiFilterMaintain({
      Obsolete: filterConditionData?.Obsolete,
      Missing: filterConditionData?.Missing,
      Good: filterConditionData?.Good,
      Bad: filterConditionData?.Bad,
      to_capitalize: filterConditionData?.to_capitalize,
      qrCode: qrcodeToggle,
      location: {
        label: selectLoction?.label,
        value: selectLoction?.value,
        logo: selectLoction?.logo,
      },
      department: {
        label: selectDepartment?.label,
        value: selectDepartment?.value,
      },
    });
    setMultiSelectData([
      filterConditionData?.Obsolete,
      filterConditionData?.Missing,
      filterConditionData?.Good,
      filterConditionData?.Bad,
      filterConditionData?.to_capitalize,
    ]);
    if (token) {
      dispatchResetFixedAssetRegisterListing();
      dispatchResetFixedAssetRegisterSuccess();
      dispatchResetFixedAssetRegisterMessage();
      dispatchResetFixedAssetRegisterTotalCount();
      dispatchResetFixedAssetRegisterStatusCode();
      dispatchResetFixedAssetRegisterError();

      if (offset === 0) {
        const trueKeys: string[] = Object.keys(filterConditionData).filter(
          (key) => filterConditionData[key] === true
        );
        const resultString = trueKeys.join(",");
        let finalData = {
          token,
          client_code,
          sort_by: sortByLocation?.name
          ? "location"
          : sortByDeparment?.name
          ? "department"
          : sortByOldest?.name
          ? "updated_at"
          : "",
        sort_by_value: sortByLocation?.value
          ? sortByLocation?.value
          : sortByDeparment?.value
          ? sortByDeparment?.value
          : sortByOldest?.value
          ? sortByOldest?.value
          : "",
          is_verified: 1,
          searchValue: searchValue,
          condition: resultString,
          limit,
          offset,
          location: selectLoction?.value ? selectLoction?.value : "",
          qr_code: qrcodeToggle === 1 ? 0 : "",
          department: selectDepartment?.value ? selectDepartment?.value : "",
        };
        dispatchGetFixedAssetRegisterListing(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
              dispatchResetFixedAssetRegisterSuccess();
              dispatchResetFixedAssetRegisterMessage();
              dispatchResetFixedAssetRegisterStatusCode();
            }}
          />
        );
      }
    }
  };

  return (
    <div
      className="d-flex physical-verification"
      style={{
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {windowWidth <= 430 ? null : (
        <div className="mb-3">
          <CommonHeader
            title="Physical Verification"
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      )}

      {windowWidth <= 430 ? (
        isVisible ? (
          <QrCodeScanner
            getSingleData={getSingleData}
            singleFixedAsset={singleFixedAsset}
            handleReset={handleReset}
            onClose={onClose}
            handleSubmit={handleSubmit}
            message={message}
          />
        ) : (
          <div>
            <div
              style={{
                padding: "15px 30px 40px 30px",
                background: "#fff",
                marginLeft: "-38px",
                marginRight: "-50px",
              }}
            >
              {/* <button
                onClick={() => setIsVisible(true)}
                className="btn btn-primary w-100"
              >
                Scan QR Code
              </button> */}
              <div className="main-header">
              <div className="mt-2 p-0 header">
                <span className="ml-3">Recently Verified Assets</span>
              <div className="sub-header">
                Total {totalCount} assets found
              </div>
              </div>
              <div>
             <PhysicalVerificationDownloadReport 
             filterConditionData={filterConditionData} 
             client_code={client_code}
             searchValue={searchValue}
             token={token}
             selectDepartment={selectDepartment}
             sortByOldest={sortByOldest}
             sortByLocation={sortByLocation}
             sortByDeparment={sortByDeparment}
             company_name={company_name}
             />
             </div>
              </div>  
              <div
                className="d-flex"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div className="col-md-3">
                  <span
                    style={{ position: "absolute", top: "4px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    onChange={handleSearch}
                    style={{ paddingLeft: "35px" }}
                    value={searchValue}
                  />
                </div>

                <FixedAssetFilter
                  type={"mobileDevice"}
                  history={history}
                  toggle={toggle}
                  setToggle={setToggle}
                  locationListValue={locationListValue}
                  selectLoction={selectLoction}
                  handleLoctionChange={handleLoctionChange}
                  filterConditionData={filterConditionData}
                  setFilterConditionData={setFilterConditionData}
                  handleApplyFilterData={handleApplyFilterData}
                  clearFilter={clearFilter}
                  setMultiSelectData={setMultiSelectData}
                  multiSelectData={multiSelectData}
                  setQRCodeToggle={setQRCodeToggle}
                  qrCodeToggle={qrcodeToggle}
                  multiFilterMaintain={multiFilterMaintain}
                  setSelectLoction={setSelectLoction}
                  selectDepartment={selectDepartment}
                  departmentListValue={departmentListValue}
                  handleDepartmentChange={handleDepartmentChange}
                  setMultiFilterMaintain={setMultiFilterMaintain}
                />
                 <div>
                  <FixedAssetSorting
                    data={data}
                    handleChange={handleSort}
                    selectedData={
                      sortByLocation?.value
                        ? sortByLocation
                        : sortByDeparment?.value
                        ? sortByDeparment
                        : sortByOldest?.value
                        ? sortByOldest
                        : sortByCf
                    }
                    history={history}
                    type={"physicalVerification"}
                  />
                </div>
             
              </div>
            </div>

            {fetching && offset === 0 ? (
              <TableLoader Rows={7} ColumnPerRow={4} />
            ) : listData?.length > 0 ? (
              listData?.map((item: any) => {
                return <SingleCard data={item} />;
              })
            ) : (
              fetching === false &&
              listData?.length === 0 && (
                <div className="mt-5">
                  <EmptyListPage
                    title="No Fixed Asset List Found"
                    image={EmptyClientList}
                    imageWidth="25%"
                  />
                </div>
              )
            )}
          </div>
        )
      ) : (
        <div className="mt-5">
          <EmptyListPage
            title="Please Login From Mobile Device To Visit This Page"
            image={UnauthorizeImage}
            imageWidth="25%"
          />
        </div>
      )}
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.fixedAssetRegister.success,
  fetching: state.fixedAssetRegister.fetching,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  finacAssetListing: state.fixedAssetRegister.finacAssetListing,
  totalCount: state.fixedAssetRegister.totalCount,
  departmentList: state.clientSettings.departmentList,
  singleFixedAsset: state.fixedAssetRegister.singleFixedAsset,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterListing: () =>
    dispatch(resetFixedAssetRegisterListing()),
  dispatchGetFixedAssetRegisterListing: (data: any) =>
    dispatch(getFixedAssetRegisterListing(data)),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchDeleteFixedAssetRegisterAction: (data: any) =>
    dispatch(deleteFixedAssetRegisterAction(data)),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchResetFixedAssetRegisterStatusCode: () =>
    dispatch(resetFixedAssetRegisterStatusCode()),
  dispatchResetFixedAssetRegisterTotalCount: () =>
    dispatch(resetFixedAssetRegisterTotalCount()),
  dispatchGetSingleFixedAsset: (data: any) =>
    dispatch(getSingleFixedAsset(data)),
  dispatchResetSingleFixedAsset: () => dispatch(resetSingleFixedAsset()),
  dispatchPostFixedAssetVerificationAction: (
    data: FixedAssetVerificationType
  ) => dispatch(postFixedAssetVerificationAction(data)),
  dispatchGetDepartmentList: (data: GetDepartmentListPayloadType) => {
    dispatch(getDepartmentListAction(data));
  },
  dispatchResetDepartmentList: () => dispatch(resetDepartmentList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhysicalVerification);
